export const Marquee = () => {
  const items = Array.from({ length: 8 });
  return (
    <div data-testid="marquee-section" className="py-10 md:py-14 overflow-hidden" aria-hidden="true">
      <div className="jpd-marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((_, i) => (
              <span
                key={i}
                className="font-display uppercase font-semibold text-4xl md:text-6xl tracking-wide text-transparent whitespace-nowrap px-6"
                style={{ WebkitTextStroke: "1px rgba(255,255,255,0.12)" }}
              >
                Shine like new every drive.
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
